/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ reps: NonNullable<unknown>, date: NonNullable<unknown> }} Share_Record_LineInputs */

const en_us2_share_record_line = /** @type {(inputs: Share_Record_LineInputs) => LocalizedString} */ (i) => {
	if ((i?.reps === 1 || i?.reps === "1")) return /** @type {LocalizedString} */ (`1 rep · ${i?.date}`);
	return /** @type {LocalizedString} */ (`${i?.reps} reps · ${i?.date}`)
	
};

const pt_br2_share_record_line = /** @type {(inputs: Share_Record_LineInputs) => LocalizedString} */ (i) => {
	if ((i?.reps === 1 || i?.reps === "1")) return /** @type {LocalizedString} */ (`1 repetição · ${i?.date}`);
	return /** @type {LocalizedString} */ (`${i?.reps} repetições · ${i?.date}`)
	
};

const es_419_share_record_line = /** @type {(inputs: Share_Record_LineInputs) => LocalizedString} */ (i) => {
	if ((i?.reps === 1 || i?.reps === "1")) return /** @type {LocalizedString} */ (`1 repetición · ${i?.date}`);
	return /** @type {LocalizedString} */ (`${i?.reps} repeticiones · ${i?.date}`)
	
};

const pt_pt2_share_record_line = /** @type {(inputs: Share_Record_LineInputs) => LocalizedString} */ (i) => {
	if ((i?.reps === 1 || i?.reps === "1")) return /** @type {LocalizedString} */ (`1 repetição · ${i?.date}`);
	return /** @type {LocalizedString} */ (`${i?.reps} repetições · ${i?.date}`)
	
};

const fr_fr2_share_record_line = /** @type {(inputs: Share_Record_LineInputs) => LocalizedString} */ (i) => {
	if ((i?.reps === 1 || i?.reps === "1")) return /** @type {LocalizedString} */ (`1 répétition · ${i?.date}`);
	return /** @type {LocalizedString} */ (`${i?.reps} répétitions · ${i?.date}`)
	
};

const de_de2_share_record_line = /** @type {(inputs: Share_Record_LineInputs) => LocalizedString} */ (i) => {
	if ((i?.reps === 1 || i?.reps === "1")) return /** @type {LocalizedString} */ (`1 Wdh. · ${i?.date}`);
	return /** @type {LocalizedString} */ (`${i?.reps} Wdh. · ${i?.date}`)
	
};

const it_it2_share_record_line = /** @type {(inputs: Share_Record_LineInputs) => LocalizedString} */ (i) => {
	if ((i?.reps === 1 || i?.reps === "1")) return /** @type {LocalizedString} */ (`1 ripetizione · ${i?.date}`);
	return /** @type {LocalizedString} */ (`${i?.reps} ripetizioni · ${i?.date}`)
	
};

/**
* | reps | output |
* | --- | --- |
* | "1" | "1 rep · {date}" |
* | * | "{reps} reps · {date}" |
*
* @param {Share_Record_LineInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const share_record_line = /** @type {((inputs: Share_Record_LineInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Record_LineInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_share_record_line(inputs)
	if (locale === "es-419") return es_419_share_record_line(inputs)
	if (locale === "pt-PT") return pt_pt2_share_record_line(inputs)
	if (locale === "fr-FR") return fr_fr2_share_record_line(inputs)
	if (locale === "de-DE") return de_de2_share_record_line(inputs)
	if (locale === "it-IT") return it_it2_share_record_line(inputs)
	return en_us2_share_record_line(inputs)
});
export { share_record_line as "share.record_line" }